<template>
  <plain-form :can-back="true" @submit.prevent="doSend" @back="toList">
    <vuex-email-form-item label="メールアドレス" bind="email" />
    <template #submit-button>
      <invite-button class="px-5" />
    </template>
  </plain-form>
</template>

<script>
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import PlainForm from '@/views/templates/forms/PlainForm'
import VuexEmailFormItem from '@/views/molecules/formItems/VuexEmailFormItem'
import InviteButton from '@/views/molecules/buttons/InviteButton'

export default {
  name: 'BrokerInvite',
  components: {
    PlainForm,
    VuexEmailFormItem,
    InviteButton,
  },
  mixins: [AddonLoadPageEvent],
  provide: {
    bindModule: 'provisional_broker_form'
  },
  mounted() {
    this.$store.commit('provisional_broker_form/resetData');
  },
  methods: {
    doSend() {
      this.$store.dispatch('provisional_broker_form/send').then(() => {
        this.$root.showFlashMessage();
      }).catch(reason => this.$root.failApi(reason));
    },
    toList() {
      this.$router.push({name: 'BrokerList'});
    },
  }
}
</script>
